export default __webpack_public_path__ + "static/Litepaper - Chinese-eeb96ff91a890a908f8931016d8440d8.pdf";